import { AxiosError, AxiosResponse } from "axios";
import http from "utilities/http-common";

const baseUrl = "/api/attachments";

/**
 * Delete Attachment from the backend.
 *
 * @param attachmentId - GUID of the Attachment that is going to be deleted.
 */

export async function deleteAttachmentAsync(
    attachmentId: string,
    completionHash?: string
): Promise<void> {
    // TODO : Fix ResponseMessage (front & backend)
    await http
        .delete(`${baseUrl}/delete-attachment/${attachmentId}?completionHash=${completionHash}`)
        .catch((error: AxiosError) => {
            // TODO : Remove this console.log
            // TODO : implement error handling
            console.error(error);
        });
}

export async function getAttachment(id: string): Promise<Blob> {
    var url = `${baseUrl}/get-file?id=${id}`;

    return http
        .get(url, { responseType: 'blob' as 'json' })
        .then((resp: AxiosResponse<Blob>) => {
            return resp.data;
        });
}

//* Upload & Get methods are in application-service.ts
//* Reasoning: They use same base url.
